<template>
  <v-container class="pb-5 pt-0 px-0">
      <v-data-table
      dense
      :headers="headers"
      :items="list"
      :items-per-page="pagination.limit"
      hide-default-footer>
        <!-- <template v-slot:item.data_inicio_monitoramento="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pr-2">
                <v-icon :color="!item.erro? 'success' : 'error'" small>
                  {{!item.erro? 'fas fa-check-circle': 'fas fa-exclamation-circle' }}
                </v-icon>
              </span>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;"
              >
              {{ item.erro? 'Pendente' : 'Monitorado' }}
              </span>
          </v-tooltip>
        </template> -->
        <template v-slot:item.dt_upload="{item}">
          {{item.dt_upload | formatDate }}
        </template>
        <template v-slot:item.status="{item}">
          <span v-if="item.status"><v-icon  :color="statusDoc[item.status].color" size="13px" class="pr-1">fas fa-circle</v-icon >
          {{statusDoc[item.status].descricao}}</span>
        </template>
        <template v-slot:item.acoes="{item}">
          <v-menu left offset-x :nudge-width="250" max-width="250px">
            <template v-slot:activator="{ on, attrs }">
               <v-btn v-bind="attrs" v-on="on" small color="error" icon v-if="item.status==4">
               <v-icon small color="error">fa-exclamation-circle</v-icon>
              </v-btn>
            </template>
             <v-card>
               <v-card-text>
              {{ item.mensagem }}
               </v-card-text>
             </v-card>
          </v-menu>
          <v-btn @click="confirmDeleteDocumentoUpload(item)" small color="primary" :disabled="item.status!=4" icon>
              <v-icon small>fas fa-trash-alt</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pagination.total_pages"
          @input="updatePage(page)"
        ></v-pagination>
      <!-- <UploadsErrosDlg
        :dialog="showErros"
        :showClose="() => {showErros = false; dadosDoArquivo = {}}"
        :dadosDoArquivo="dadosDoArquivo"
        :error="itemError"
        :critica="itemCritica"
        :parameter="false"
        :showValue="showValue"
        :errorType="errorType"
        :userData="userData"
      /> -->
  </v-container>
</template>

<script>
// import UploadsErrosDlg from '@/components/recebiveis/uploads_monitor/UploadsErrosDlg'
export default {
    components:{
      // UploadsErrosDlg
    },
    data() {
      return {
        headers: [
            { text: "Nome do arquivo", value: "nome", sortable: false },
            { text: "Operadora", value: "oper_nome", sortable: false },
            { text: "Prestador", value: "prest_nome", sortable: false },
            { text: "Data do upload", value: "dt_upload", sortable: false },
            { text: "Enviado por", value: "username_upload", sortable: false },
            { text: "Status", value: "status", sortable: false },
            { text: "Ações", value: "acoes", align: "center", width: "90px", sortable: false },
        ],
        showErros: false,
        page: 1,
        statusDoc: {
            0: { id: null, descricao: 'Selecione',  color: null },
            1: { id: 1, descricao: "", color: "#FFFFFF", icon: "fa-circle"}, //Em validação
            2: { id: 2, descricao: "Em processamento", color: "#FC9D0A", icon: "fa-circle"},
            4: { id: 4, descricao: "Erro no arquivo", color: "#D0021B", icon: "fa-circle" },
            3: { id: 3, descricao: "Upload processado", color: "#32B88B", icon: "fa-circle"}
        }
      }
    },
    watch:{
      pagination:{
        deep: true,
        handler(val){
          if(val.current_page)
            this.page = val.current_page
        }
      }
    },
    props: {
        list: Array,
        pagination: Object,
        updatePage: Function,
        deleteDocumentoUpload: Function
    },
    methods: {
      confirmDeleteDocumentoUpload(item){
         
         let paramModal = {
          type: "warning",
          title: "Deseja realmente excluir o arquivo?",
          message: `O arquivo <b>${item.nome}</b>, enviado por <b>${item.username_upload}</b><br>será excluído e não será possível recuperá-lo após a confirmação.`,
          callback: () => this.deleteDocumentoUpload(item),
          btConfirm: { name: "Excluir", show: true },
          btCancel: { name: 'Cancelar', show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        
      }
    //   showOpen(item) {
    //     this.dialog = true
    //     let obj = {
    //       prestador_id: item.prestador_id,
    //       operadora_ans_id: item.operadora_ans_id,
    //       logins: item.logins,
    //       list: [
    //         {
    //           date_evento: '2020-12-09T00:00',
    //           evento: 'Portal indisponível'
    //         },
    //         {
    //           date_evento: '2020-12-08T00:00',
    //           evento: 'Nenhum pag. identificado'
    //         },
    //         {
    //           date_evento: '2020-12-07T00:00',
    //           evento: 'Portal indisponível'
    //         }
    //       ]
    //   }
    //   this.historico = obj
    // },
    },
}
</script>

<style>

</style>